// @ts-ignore
import * as zhCNJSON from './zh-CN.json';

export default {
  ...zhCNJSON,
};
